<div class="border border-mediumColor rounded-md">
  <div class="gap-3 p-3">
    <em-search-input
      class="product-filter"
      (inputChange)="searchProducts($event)"
    ></em-search-input>
  </div>
  <div class="list-pane available-products">
    @if (!productLimit) {
      <div class="border-b border-mediumColor flex p-2 items-center">
        <div>
          {{ getShownProductCount() }}
          {{
            'CAMPAIGN_PERFORMANCE_FILTER_OFFER_IDS_SELECTABLE_PRODUCTS'
              | translate
          }}
        </div>
        <div class="ml-auto">
          <em-button
            icon=""
            type="text"
            color="basic"
            (btnClick)="addAllFilteredToList('manuallyAdded')"
          >
            <mat-icon class="text-success-500 mr-1"> add_circle </mat-icon>
            <span class="text-success-500" translate
              >ADD_ALL_PRODUCTS_TO_FILTER</span
            >
          </em-button>
          <em-button
            type="text"
            color="basic"
            (btnClick)="addAllFilteredToList('manuallyRemoved')"
          >
            <mat-icon class="text-danger-500 mr-1"> remove_circle </mat-icon>
            <span class="text-danger-500" translate
              >EXCLUDE_ALL_PRODUCTS_FROM_FILTER</span
            >
          </em-button>
        </div>
      </div>
    }

    @for (product of availableProducts; track product) {
      <div class="item-wrapper">
        <em-product-item
          (productSelected)="onAdded($event, product)"
          [product]="product"
          [showIncludeIcon]="true"
          [showExcludeIcon]="!productLimit"
          [disabled]="product.selected || limitReached"
        >
        </em-product-item>
      </div>
    }
    @if (
      availableProducts &&
      totalProducts &&
      totalProducts > (availableProducts?.length || 0) &&
      !isLoadingProducts
    ) {
      <em-button
        class="block text-center mb-2"
        [type]="'text'"
        [icon]="'autorenew'"
        (btnClick)="loadMoreProducts()"
        >{{ 'ACTIVITIES_ACTION_LOAD_MORE' | translate }}</em-button
      >
    }
  </div>
</div>
<div>
  <div class="list-panel">
    <div class="filter-group-header">
      <div class="filter-group-headline added">
        <span translate>FILTER_MANUAL_INCLUDED</span>
        ({{ productsFromList('manuallyAdded').length }})
      </div>
      <em-button
        class="remove-all"
        type="text"
        color="basic"
        icon="delete"
        [disabled]="!productsFromList('manuallyAdded').length"
        (btnClick)="removeAllFromList('manuallyAdded')"
      >
        <span translate>REMOVE_ALL_PRODUCTS_FROM_FILTER_LIST</span>
      </em-button>
    </div>
    <div class="list">
      @for (product of productsFromList('manuallyAdded'); track product) {
        <div role="listitem">
          <em-product-item class="result" [product]="product">
            <div class="delete-action">
              <mat-icon
                class="align-right delete"
                aria-label="delete"
                (click)="remove(product)"
              >
                delete
              </mat-icon>
            </div>
          </em-product-item>
        </div>
      }
    </div>

    @if (!productLimit) {
      <div class="filter-group-header !mt-2">
        <div class="filter-group-headline excluded">
          <span translate>FILTER_MANUAL_EXCLUDED</span>
          ({{ productsFromList('manuallyRemoved').length }})
        </div>
        <em-button
          class="remove-all"
          type="text"
          color="basic"
          icon="delete"
          [disabled]="!productsFromList('manuallyRemoved').length"
          (btnClick)="removeAllFromList('manuallyRemoved')"
        >
          <span translate>REMOVE_ALL_PRODUCTS_FROM_FILTER_LIST</span>
        </em-button>
      </div>
      <div class="list">
        @for (product of productsFromList('manuallyRemoved'); track product) {
          <div role="listitem">
            <em-product-item class="result" [product]="product">
              <div class="delete-action">
                <mat-icon
                  class="align-right delete"
                  aria-label="delete"
                  (click)="remove(product)"
                >
                  delete
                </mat-icon>
              </div>
            </em-product-item>
          </div>
        }
      </div>
    }
  </div>
</div>
